// extracted by mini-css-extract-plugin
export default {"root":"yOmxbUii1bEG4YeTUPn9","imported":"Ook4BxGpLXQcJnFsrMkD","gmail":"c5SFMRh82GIXjIKg8ILf","outlook":"GCSRVDZ9XiZW1vdNs3sY"};